import React, { SyntheticEvent, useState } from "react";
import {
  Table,
  ScrollArea,
  Grid,
  Button,
  Divider,
  ActionIcon,
} from "@mantine/core";
import { Edit, Archive } from "tabler-icons-react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { deleteCollege, getCollegeDetails } from "./queries";
import { Form } from "./form";

const CollegeView = () => {
  const [isOpenForm, setOpenForm] = useState(false);
  const [data, setData] = useState<CollegeProps | null>(null);

  const queryClient = useQueryClient();

  const { mutate: mutDeleteCollege } = useMutation(deleteCollege, {
    onSuccess: (newData) => {
      queryClient.invalidateQueries();
    },
  });

  const { isLoading, data: collegeData = [] } = useQuery(
    "colleges",
    getCollegeDetails,
    {
      staleTime: 60000,
      refetchOnWindowFocus: false,
    }
  );

  const onUpdateData = (payload: CollegeProps) => {
    setData(payload);
    setOpenForm(true);
  };

  const onRestForm = () => {
    setOpenForm(false);
    setData(null);
  };

  const rows =
    collegeData &&
    collegeData.map((row: CollegeProps) => {
      return (
        <tr key={row.id}>
          <td>{row.id}</td>
          <td>{row.college_id}</td>
          <td>{row.short_name}</td>
          <td>{row.full_name}</td>
          <td>{row.order_id}</td>
          <td>{row.location}</td>
          <td>
            <Grid columns={2}>
              <Grid.Col span={1}>
                <ActionIcon
                  title="Update"
                  onClick={() => onUpdateData({ ...row })}
                >
                  <Edit size={25} strokeWidth={2} color={"green"} />
                </ActionIcon>
              </Grid.Col>
              <Grid.Col span={1}>
                <ActionIcon
                  title="Delete"
                  onClick={() => mutDeleteCollege({ id: Number(row.id) })}
                >
                  <Archive size={25} strokeWidth={2} color={"red"} />
                </ActionIcon>
              </Grid.Col>
            </Grid>
          </td>
        </tr>
      );
    });

  if (isLoading) {
    // TODO loader on data loading
    return null;
  }
  return (
    <>
      <Grid justify={"flex-end"}>
        <Grid.Col lg={1}>
          <Button
            variant="light"
            onClick={(e: SyntheticEvent) => setOpenForm(true)}
          >
            Create
          </Button>
        </Grid.Col>

        <Grid.Col>
          <Divider />
          <ScrollArea
            offsetScrollbars
            style={{ height: 700, padding: 15 }}
            scrollHideDelay={1000}
          >
            <Table
              sx={{ minWidth: 800 }}
              verticalSpacing="xs"
              horizontalSpacing={"xl"}
            >
              <thead>
                <tr>
                  <th>Id</th>
                  <th>College Id</th>
                  <th>Short Name</th>
                  <th>Full Name</th>
                  <th>Order</th>
                  <th>Location</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </Table>
          </ScrollArea>
        </Grid.Col>
      </Grid>
      <Form
        isOpenModal={isOpenForm}
        setOpenForm={setOpenForm}
        onReset={onRestForm}
        data={data}
      />
    </>
  );
};

export default CollegeView;
